<template>
    <div>
        <b-row
            v-if="
                purchase.contract.supplementary_agreements && ((purchase.contract.supplementary_agreements.length === 0 && $store.getters.isLoggedIn && purchase.is_customer && purchase.actions.customer.supplementary_agreement !== 'disallow') || purchase.contract.supplementary_agreements.length > 0)
            ">
            <b-col class="d-flex justify-content-between align-items-center">
                <text-header id="atmo-contract-annexes" class="atmo-hash-jump-point">Дополнительные соглашения</text-header>
            </b-col>
        </b-row>
        <div v-if="purchase.contract.supplementary_agreements.length > 0" class="accordion" role="tablist">
            <component
                v-for="(supplementaryAgreement, key) in purchase.contract.supplementary_agreements"
                :key="`supplementary-agreement-${key}`"
                :is="supplementaryAgreementComponent(supplementaryAgreement)"
                :title="`${supplementaryAgreement.type.title} №${supplementaryAgreement.number}`"
                :purchase="purchase"
                :supplementary-agreement="supplementaryAgreement"
                :visible="purchase.contract.latest_supplementary_agreement_id === supplementaryAgreement.id"
                @refresh="refresh($event)" />
        </div>
        <private-fl44-unknown-volume-send-supplementary-agreement-customer-block v-if="$store.getters.isLoggedIn && purchase.is_customer && purchase.actions.customer.supplementary_agreement === 'create'" :purchase="purchase" @refresh="refresh($event)" />
    </div>
</template>

<script>
import PrivateFl44UnknownVolumeSendSupplementaryAgreementCustomerBlock from '@/components/products/fl44-unknown-volume/partials/private-fl44-unknown-volume-send-supplementary-agreement-customer-block.vue';
import Fl44UnknownVolumeSupplementaryAgreementItem from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-supplementary-agreement-item.vue';
import Fl44UnknownVolumeSupplementaryAgreementTerminationItem from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-supplementary-agreement-termination-item.vue';

export default {
    name: 'fl44-unknown-volume-supplementary-agreement-block',
    components: { PrivateFl44UnknownVolumeSendSupplementaryAgreementCustomerBlock },
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    methods: {
        refresh(newHash = null) {
            this.$emit('refresh', newHash);
        },
        supplementaryAgreementComponent(supplementaryAgreement) {
            switch (supplementaryAgreement.type.id) {
                case 'termination':
                    return Fl44UnknownVolumeSupplementaryAgreementTerminationItem;
                default:
                    return Fl44UnknownVolumeSupplementaryAgreementItem;
            }
        }
    }
};
</script>
